/* global Fw, tinyMCE */

(function($, d, g) {
    /* jshint validthis: true */
	"use strict";

    function catalogCloseDetails(e) {
        catalogToggleDetails(e, ".catalog-product.selected");
    }
    function catalogToggleDetails(e, sel) {
        var aCls = "selected",
            $el = $(sel || this);

        $(window).off("resize", catalogAppendDetails);
        if ($el.hasClass(aCls)) {
            $el.removeClass(aCls);
            window.history.replaceState({}, document.title, location.pathname + location.search);
        } else {
            $(".catalog-product." + aCls).removeClass(aCls);
            $el.addClass(aCls);
            $(window).on("resize", catalogAppendDetails);
            window.history.replaceState({}, document.title, location.pathname + location.search + '#' + $el.attr('id'));
        }
        catalogAppendDetails();
    }
    function catalogAppendDetails(e) {
        var $all = $(".catalog-products-ctner").children(),
            $els = $all.filter(".catalog-product"),
            $el = $els.filter(".selected"),
            $cnts = $els.find(".catalog-product-details"),
            $ctn = $all.filter(".catalog-products-detailer"),
            $ctnCnt = $ctn.find(".catalog-products-detailer-content"),
            ind = $els.index($el),
            pos = $all.index($ctn),
            old = $ctn.attr("data-index"),
            bigScreen = window.innerWidth >= 1024;

        if (old && !e) {
            $ctnCnt.children().appendTo($cnts.eq(old));
        }
        if (ind === -1) {
            $ctn.hide();
            return;
        }
        if (!e) {
            $cnts.eq(ind).children().appendTo($ctnCnt);
            $ctn.attr("data-index", ind);
            $ctn.show();
        }
        if (bigScreen && ind % 2 === 0 && ind !== $els.size() - 1) {
            if (ind !== pos - 2) {
                $els.eq(ind + 1).after($ctn);
            }
        } else if (ind !== pos - 1) {
            $el.after($ctn);
        }
    }
    
    function catalogAddCart(e) {
        e.preventDefault();
        var form = this;
        var opts = form.elements.namedItem("option1");
        var cartData = "";

        if (opts) {
            if (!opts.length) {
                if (opts.checked && opts.value !== "") {
                    cartData = opts.getAttribute("data-cart");
                }
            } else {
                for (var i = 0; i < opts.length; i++) {
                    if (opts[i].checked && opts[i].value !== "") {
                        cartData = opts[i].getAttribute("data-cart");
                        break;
                    }
                }
            }
        }
                
        if (cartData === "") {
            form.querySelector(".errorMessage").style.display = "block";
        } else {
            form.elements.namedItem("data").value = cartData;
            setTimeout(function () {
                form.submit();
            });
        }
    }
    function catalogOptionSelected(e) {
        if (this.checked) {
            this.form.querySelector(".errorMessage").style.display = "none";
        }
    }
    
    function filterMyProducts() {
        var filters = document.getElementsByClassName("my-products-filters-select"),
            els = document.getElementsByClassName("my-product");

        for (var i = 0; i < els.length; i++) {
            var el = els[i],
                hide = "";

            $(el).removeClass("none");
            for (var j = 0; j < filters.length; j++) {
                var filter = filters[j],
                    type = filter.type,
                    val = filter.value.toLowerCase(),
                    name = filter.name,
                    attr = el.getAttribute("data-" + name).toLowerCase();

                switch (type) {
                    case "checkbox":
                    case "radio":
                        var checked = filter.checked;
                        if (checked.toString() !== attr || checked && attr === "") 
                            hide += " none";
                        break;
                    case "text":
                        if (val.trim() !== "" && attr.indexOf(val) === -1) 
                            hide += " none";
                        break;
                    default:
                        if (!(val === "all" || val === "" || val === attr)) 
                            hide += " none";
                        break;
                }
            }
            $(el).addClass(hide);
        }
        document.querySelector(".text-result-count").innerHTML = 
                els.length - $(els).filter(".none").size();
    }

    function openVideoPopup(e) {
        var a = this,
            b = a.nextElementSibling,
            c = a.previousElementSibling.innerHTML,
            s = b.value,
            t = b.getAttribute("data-type"),
            pop = document.getElementById("myProductsViewer"),
            wrp = pop.querySelector(".wistia_responsive_padding"),
            vfc = pop.querySelector(".my-products-viframe-ctner"),
            ctnTop = pop.querySelector(".my-products-viframe"),
            ctnBtm = pop.querySelector(".my-products-product-info>div");

        if (t === "wistia") {
            vfc.style.display = "none";
            wrp.style.display = "block";
            wrp.querySelector(".wistia_embed").src = s;
        } else {
            vfc.style.display = "block";
            wrp.style.display = "none";
            wrp.querySelector(".wistia_embed").src = "";
        }
        vfc.querySelector(".video-buffer").style.display = "none";
        vfc.querySelector(".video-controls").style.display = "none";
        ctnTop.innerHTML = "";
        switch(t) {
            case "wistia":
                break;
            case "video":
                vfc.querySelector(".video-buffer").style.display = "block";
                vfc.querySelector(".video-controls").style.display = "block";
                if (mg2vp) {
                    mg2vp.embed(ctnTop, s, b.getAttribute("data-poster"));
                } else {
                    var frame = document.createElement("VIDEO");
                    frame.src = s;
                    frame.autoplay = true;
                    frame.setAttribute("poster", b.getAttribute("data-poster"));
                    ctnTop.appendChild(frame);
                }
                break;
            case "embed":
                ctnTop.innerHTML = s;
                break;
            case "vimeo":
                var re;
                if (navigator.userAgent.match(/Safari\//)) {
                    // Safari error regexp, doesn't support lookbehind group
                    re = new RegExp('(?:\w\/)[a-f0-9]+(?=[\/\?]|$)', 'g');
                } else {
                    re = new RegExp('(?<=\w\/)[a-f0-9]+(?=[\/\?]|$)', 'g');
                }
                var code = s.match(re);
                s = "https://player.vimeo.com/video/" + code[0] + (code.length > 1 ? "?h=" + code[1] : "");
            default:
                ctnTop.innerHTML = '<iframe src="' + s + '" frameborder="0" allowfullscreen></iframe>';
                break;
        }
        ctnBtm.innerHTML = c;
        pop.style.display = "block";
        pop.oncontextmenu = function(e) {
            e.preventDefault();
        };
        document.body.style.overflow = "hidden";
    }
    function closeVideoPopup(e) {
        var pop = document.getElementById("myProductsViewer"),
            ctnTop = pop.querySelector(".my-products-viframe"),
            ctnBtm = pop.querySelector(".my-products-product-info>div");

        pop.style.display = "none";
        ctnTop.innerHTML = ctnBtm.innerHTML = "";
        document.body.style.overflow = "";
    }
	
	function init() {
        // Section Shop
        $(".catalog-webinar").on("click", catalogToggleDetails);
        $(".catalog-products-detailer-close").on("click", catalogCloseDetails);
        $(".cpd-price-option-checker input").on("change", catalogOptionSelected);
        $(".cpd-add-cart-form").on("submit", catalogAddCart);
        
        // Section Account
        $(".my-products-filters-select").on("change", filterMyProducts);
        $(".catalog-product-opener").on("click", openVideoPopup);
        $(".my-products-popup .popup-close-btn").on("click", closeVideoPopup);
    }
	
	$(g).ready(init);
	
})(jQuery, document, window);

(function($) {
	'use strict';
    
    var mg2vp = {};
	var videoCtn;
	var videoElt;
    var videoCtrl;
	var playPauseBtn;
	var updateInterval;
	var timeIn;
	var timeOut;
	var cursor;
	var progressBar;
	var progressBarCtn;
	var muteBtn;
	var muteBar;
    var muteBarCurrent;
	var volume;
	var currentProgress;
	var nextProgress;

	var init = function () {
        videoCtrl = $('.video-controls');
		playPauseBtn = $('.video-play-pause');
		timeIn = $('.video-time-in');
        setTime(timeIn, 0);
		timeOut = $('.video-time-out');
        setTime(timeOut, 0);
		cursor = $('.video-progress-bar-cursor');
		progressBar = $('.video-progress-bar-progress');
		progressBarCtn = $('.video-progress-bar');
		muteBtn = $('.video-volume');
		muteBar = $('.video-volume-inner');
        muteBarCurrent = $('.video-volume-current');
		volume = 1;
        currentProgress = '000';
		nextProgress = '000';
	};
    var destroy = function() {
        pauseVideo();
        videoElt.off('waiting seeking playing seeked canplay', toggleBuffering);
		videoElt.off('ended', handleVideoEnd);
        progressBarCtn.off('mousedown touchstart', goToTimeCode);
		progressBarCtn.off('mouseover mouseout', overProgress);
        progressBarCtn.off('mousemove', updateOverProgress);
		muteBtn.off('click', toggleMute);
		muteBar.off('mousedown', changeVolume);
		playPauseBtn.off("click", togglePlay);
        $(window).off("resize", videoResize);
        videoCtn = undefined;
        videoElt = undefined;
        videoCtrl = undefined;
        playPauseBtn = undefined;
        updateInterval = undefined;
        timeIn = undefined;
        timeOut = undefined;
        cursor = undefined;
        progressBar = undefined;
        progressBarCtn = undefined;
        muteBtn = undefined;
        muteBar = undefined;
        muteBarCurrent = undefined;
        volume = undefined;
        currentProgress = undefined;
        nextProgress = undefined;
    };
    
	/* ====== VIDEO SETUP ====== */
	var createVideo = function(videoElemCtn, videoUrl, vidPoster) {
		var videoSource = '<source src="' + videoUrl + '" type="video/mp4">';
		var videoElem = $('<video preload="auto" class="mg2vp-element"/>');
		
        init();
		videoElem.append(videoSource);
		videoElem.append('<p>Your user agent does not support the HTML5 Video element.</p>');
        videoCtn = $(videoElemCtn);
		videoCtn.append(videoElem);
        if (vidPoster) videoElem.attr("poster", vidPoster);
        
        videoElt = videoElem;
        videoElem.on('loadedmetadata', function() {
            // HACK: Fix stuck frames in Firefox
            videoElem[0].currentTime = 0.01;
            setVideoTime(videoElem);
            setupVideo(videoElem);
            setupVideoControls();
            $(window).on("resize", videoResize);
        });
	};
	var setVideoTime = function(videoElem) {
        var videoDuration = videoElem[0].duration;
		setTime(timeIn, videoElem[0].currentTime, videoDuration);
		setTime(timeOut, videoDuration);
		moveProgress(0, videoDuration);
		toggleBuffering({type: 'seeked'});
	};
	var setTime = function(elt, val, total) {
		var time = getTime(val);
		var hours = total && total >= 3600 ? '00:' : '';
        
        if (parseInt(time.hours) > 0) {
            hours = time.hours + ':';
        }
		elt.text(hours + time.minutes + ':' + time.seconds);
	};
	var getTime = function(timeVal) {
		var time = {};
		time.hours = padValue(Math.floor(timeVal / 3600), 2);
		time.minutes = padValue(Math.floor((timeVal / 60) % 60), 2);
		time.seconds = padValue(Math.floor(timeVal % 60), 2);
		return time;
	};
	var padValue = function(val, len) {
		var valueToPad = isNaN(val) ? '0' : val.toString();
		while(valueToPad.length < len) {
			valueToPad = '0' + valueToPad;
		}
		return valueToPad;
	};
	var setupVideo = function(videoElem) {
		videoElem[0].volume = volume;
		videoElem.on('waiting seeking playing seeked canplay', toggleBuffering);
		videoElem.on('ended', handleVideoEnd);
	};
	var handleVideoEnd = function(e) {
		//pauseVideo();
	};
	var setupVideoControls = function() {
		progressBarCtn.on('mousedown touchstart', goToTimeCode);
		progressBarCtn.on('mouseover mouseout', overProgress);
        progressBarCtn.on('mousemove', updateOverProgress);
		muteBtn.on('click', toggleMute);
		muteBar.on('mousedown', changeVolume);
		playPauseBtn.click(togglePlay);
        $(document).on("click", controlFocus);
        $(document).on("keydown", toggleKeyAction);
	};
    var checkVideoControl = function() {
        if (!videoElt.parent()[0]) {
            $(document).off("click", controlFocus);
            $(document).off("keydown", toggleKeyAction);
            destroy();
        }
    };
    var controlFocus = function(e) {
        var targ = $(e.target).closest('.video-controls')[0];
        if (targ) {
            videoCtrl.addClass('focused');
        } else {
            videoCtrl.removeClass('focused');
        }
        checkVideoControl();
    };
    var toggleKeyAction = function(e) {
        if (videoCtrl.hasClass('focused')) {
            var k = e.which || e.keyCode;
            if (k === 32) togglePlay(e);
        }
        checkVideoControl();
    };
	var togglePlay = function(e) {
		e.preventDefault();
		if(videoElt[0].paused) {
			startVideo();
		} else {
			pauseVideo();
		}
        try {
            ga("send", "event", "webconf�rence symposium", "play/pause/watched", 
                    $("#myProductsViewer .catalog-product-info-name").text());
        } catch(err) {}
	};
	var startVideo = function() {
		videoElt[0].play();
		playPauseBtn.addClass('playing');
		updateInterval = setInterval(function() {
            var t = videoElt[0].currentTime;
            var d = videoElt[0].duration;
			setTime(timeIn, t, d);
			moveProgress(t, d);
		}, 100/3);
	};
	var pauseVideo = function() {
		videoElt[0].pause();
		playPauseBtn.removeClass('playing');
		clearInterval(updateInterval);
	};
	var toggleBuffering = function(e) {
		var buffer = $('.video-buffer', videoCtn.parent());
		var isBuffering = buffer.hasClass('buffering');
		var isPlaying = e.type === 'playing' && isBuffering;
		var wasSeeked = e.type === 'seeked' && isBuffering;
		var isWaiting = e.type === 'waiting' && !isBuffering;
		var isSeeking = e.type === 'seeking' && !isBuffering;
		var canPlay = e.type === 'canplay' && isBuffering;

		if(isPlaying || wasSeeked || isWaiting || isSeeking || canPlay || !e) {
			buffer.toggleClass('buffering');
			buffer.toggle(0);
		}
	};
	var videoResize = function(e) {
		updateProgressView();
		/*if(window.matchMedia('(max-width: 1023px)').matches && !videoElt[0].paused) {
			pauseVideo();
		}*/
	};
	/* =================== */
	
	/* ====== PROGRESS BAR ====== */
	var moveProgress = function(curr, end) {
		var progressSizePercent = curr / end;
		cursor.attr('data-percentage', progressSizePercent);
		updateProgressView(progressSizePercent);
	};
	var updateProgressView = function(percentage) {
		var value = percentage ? percentage : cursor.attr('data-percentage');
		var progressSizePixels = (value * progressBarCtn.width());

		cursor.css('transform', 'translateX(' + progressSizePixels + 'px)');
		progressBar.css('transform', 'scaleX(' + value + ')');
	};
	var overProgress = function(e) {
		var mouseOverBar = $('.video-progress-bar-mouse');

		if(e.type === 'mouseover') {
			updateOverProgress(e);
		} else if(e.type === 'mouseout'){
			mouseOverBar.width(0);
		}
	};
	var updateOverProgress = function(e) {
		e.preventDefault();
        
		var initialValue = e.pageX;
		var progressLeft = progressBarCtn.offset().left;
		var progressWidth = progressBarCtn.width();
		var clampedValue = clampValue(initialValue - progressLeft, 0, progressWidth);

		$('.video-progress-bar-mouse').width(clampedValue);
	};
	var goToTimeCode = function(e) {
		var leftBtnPressed = e.which === 1;
		if(leftBtnPressed || e.type === 'touchstart') {
			pauseVideo();
			progressBarCtn.data('wasPaused', videoElt[0].paused);
            updateTimeCode(e, true);
		}
	};
	var updateTimeCode = function(e, isClicked) {
		e.preventDefault();
        
		var initialValue = e.type === 'mousemove' || e.type === 'mousedown' ? e.pageX : e.originalEvent.touches[0].pageX;
		var progressLeft = progressBarCtn.offset().left;
		var progressWidth = progressBarCtn.width();
		var value = clampValue(initialValue - progressLeft, 0, progressWidth);
        var timeTotal = videoElt[0].duration;
		var timeConversion = value / progressWidth * timeTotal;

		setTime(timeIn, timeConversion, timeTotal);
		moveProgress(value, progressWidth);
		progressBarCtn.data('timeConversion', timeConversion);
        if (isClicked) {
            setTimeout(function() {
                $(document).on('touchmove mousemove', updateTimeCode);
                $(document).on('touchend mouseup', goToTimeCodeComplete);
            }, 20);
        }
	};
	var goToTimeCodeComplete = function(e) {
        e.preventDefault();
		$(document).off('touchmove mousemove', updateTimeCode);
		$(document).off('touchend mouseup', goToTimeCodeComplete);
        
		var timeConversion = progressBarCtn.data('timeConversion');
		var wasPaused = progressBarCtn.data('wasPaused');
		
		videoElt[0].currentTime = timeConversion;
		progressBarCtn.removeData('wasPaused');
		if(!wasPaused) {
			startVideo();
		}
	};
	var clampValue = function(val, min, max) {
		var value = isNaN(val) ? 0 : val;
		return Math.min(Math.max(min, value), max);
	};
	/* =================== */
	
	/* ====== VOLUME ====== */
	var toggleMute = function(e) {
		var volumeBeforeMute = parseFloat(muteBtn.attr('data-volume'));

		if(volumeBeforeMute > 0) {
			if(muteBtn.hasClass('mute')) {
				volume = volumeBeforeMute;
				videoElt[0].volume = volumeBeforeMute;
                muteBarCurrent.css("height", volumeBeforeMute * 100 + "%");
			} else {
				volume = 0;
				videoElt[0].volume = 0;
				muteBarCurrent.height(0);
			}
			muteBtn.toggleClass('mute');
		}
	};
	var changeVolume = function(e) {
		var leftBtnPressed = e.which === 1;

		if(e.type === 'mousedown' && leftBtnPressed) {
			updateVolume(e);
			$(document).on('mousemove', updateVolume);
			$(document).on('mouseup', changeVolume);
			muteBar.parent().addClass('opened');
		} else if(e.type === 'mouseup'){
			$(document).off('mousemove', updateVolume);
			$(document).off('mouseup', changeVolume);
			muteBar.parent().removeClass('opened');
		}
	};
	var updateVolume = function(e) {
		var initialValue = e.pageY;
		var muteT = muteBar.offset().top;
		var muteH = muteBar.height();
		var clampedValue = clampValue(initialValue - muteT, 0, muteH);
		var volumePercent = (1 - clampedValue / muteH).toFixed(4);
        
		e.preventDefault();
		volume = volumePercent;
		videoElt[0].volume = volumePercent;
		muteBarCurrent.css("height", volumePercent * 100 + "%");
		muteBtn.attr('data-volume', volumePercent);

		if(volumePercent > 0.66) {
			muteBtn.removeClass('medium low mute');
		} else if (volumePercent > 0.33 && volumePercent <= 0.66) {
			muteBtn.addClass('medium');
			muteBtn.removeClass('low mute');
		} else if (volumePercent > 0 && volumePercent <= 0.33) {
			muteBtn.addClass('low');
			muteBtn.removeClass('mute');
		} else {
			muteBtn.addClass('mute');
		}
	};
	/* =================== */
    
    mg2vp.embed = createVideo;
    window.mg2vp = window.mg2vp || mg2vp;

})(jQuery);